
















































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { EnterLeave, SearchCondition } from '@/modules/enterLeave';
import { EntryAndExitTypes, getEntryAndExitTypeName } from '@/enums/entryAndExitTypes';
import { Person } from '@/models/person';
import { ElForm } from 'element-ui/types/form';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';

interface EditInfo {
  studentList: Person[];
  enterLeaveState: EntryAndExitTypes;
  enterLeaveDateTime: Date;
}

@Component
export default class EnterLeaveList extends AvaivaledVue {
  private EntryAndExitTypes = EntryAndExitTypes;
  private getEntryAndExitTypeName = getEntryAndExitTypeName;

  private editVisible = false;
  private studentSelectVisible = false;
  private isEdit = false;
  private showSearchCondition = true;

  private enterLeaveDate: Date | null = null;
  private enterLeaveTime: Date | null = null;

  private formRule = {
    enterLeaveDateTime: [
      { required: true, message: '入退室日時を入力してください' },
      { validator: this.validateEnterLeaveDate, trigger: 'blur' },
    ],
    studentList: [
      { required: true, message: '生徒を選択してください' },
      { validator: this.validateStudentList, trigger: 'blur' },
    ],
  };

  private validateEnterLeaveDate(rule: any, value: string, callback: any) {
    if (!this.enterLeaveDate || !this.enterLeaveTime) {
      callback(new Error('入退室日時を入力してください'));
    } else {
      callback();
    }
  }

  private validateStudentList(rule: any, value: string, callback: any, source: any) {
    const studentList = source.studentList as Person[];
    if (studentList.length === 0) {
      callback(new Error('配信先を選択してください'));
    } else {
      callback();
    }
  }

  get loading(): boolean {
    return this.$store.state.enterLeave.loading;
  }

  get countAll(): number {
    if (this.$store.state.enterLeave.countAll === 0) {
      return 1;
    } else {
      return this.$store.state.enterLeave.countAll;
    }
  }

  get enterLeaveList(): EnterLeave[] {
    return this.$store.state.enterLeave.enterLeaves;
  }

  get condition(): SearchCondition {
    return this.$store.state.enterLeave.searchCondition;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private created() {
    this.pageBackCheck(FunctionTypes.EntryAndExit);
  }

  private loadData() {
    this.$store.dispatch('enterLeave/searchEnterLeaves', this.condition);
  }

  private getRowNumber(index: number) {
    return this.condition.perPage * (this.condition.page - 1) + index + 1;
  }

  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangePage() {
    this.loadData();
  }

  private onChangeSort( {prop, order}: any ) {
    if (!prop) {
      this.condition.sort = 'date descending';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private onPageSizeChange(val: number) {
    this.condition.perPage = val;
  }

  private enterLeaveDateTimeFormatter(row: EnterLeave) {
    if (!row.date) {
      return '';
    } else {
      return (this as any).$moment(row.date).format('YYYY/MM/DD HH:mm');
    }
  }

  private onChangeEnterLeaveDateTime(enterLeave: EditInfo) {
    if (!this.enterLeaveDate || !this.enterLeaveTime) {
      enterLeave.enterLeaveDateTime = null as any;
    } else {
      enterLeave.enterLeaveDateTime = new Date(
        this.enterLeaveDate.getFullYear(),
        this.enterLeaveDate.getMonth(),
        this.enterLeaveDate.getDate(),
        this.enterLeaveTime.getHours(),
        this.enterLeaveTime.getMinutes(),
      );
    }

    (this.$refs.form as any).validateField('enterLeaveDateTime');
  }

  private onClickEnterLeaveDateTimeNow(enterLeave: EditInfo) {
    const now = new Date();
    this.enterLeaveDate = new Date(now.getTime());
    this.enterLeaveTime = new Date(now.getTime());

    this.onChangeEnterLeaveDateTime(enterLeave);
  }

  private submitForm() {
    (this.$refs.form as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.enterLeaveEdit as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async onCreate() {
    this.isEdit = false;

    this.enterLeaveDate = null;
    this.enterLeaveTime = null;

    const form: EditInfo = {
      studentList: new Array<Person>(),
      enterLeaveState: EntryAndExitTypes.Entry,
      enterLeaveDateTime: new Date(),
    };

    let result: EditInfo;
    try {
      result = await (this.$refs.enterLeaveEdit as DialogWrapper).open({...form}) as EditInfo;
    } catch (error) {
      return;
    }

    const enterLeave: EnterLeave = {
      id: '',
      studentId: '',
      studentUserId: '',
      studentName: '',
      entryAndExit: result.enterLeaveState,
      entryAndExitName: getEntryAndExitTypeName(result.enterLeaveState),
      date: result.enterLeaveDateTime,
    };

    const studentList = result.studentList;
    const studentIdList = studentList.map((student) => {
      return student.id;
    });

    let studentName = `「${studentList[0].name}」`;
    if (studentList.length >= 2) {
      studentName += `　他${studentList.length - 1}名`;
    }
    const enterLeaveState = getEntryAndExitTypeName(result.enterLeaveState);
    const enterLeaveDateTime = (this as any).$moment(result.enterLeaveDateTime).format('YYYY/MM/DD HH:mm');
    const target = `${studentName}<br>${enterLeaveState}　${enterLeaveDateTime}`;
    try {
      await this.$store.dispatch('enterLeave/createEnterLeave', {
        enterLeave,
        studentIdList,
      });
      this.$notify({
        title: '登録完了',
        message: `<strong>${target}</strong><br>を登録しました。`,
        position: 'bottom-right',
        dangerouslyUseHTMLString: true,
      });
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
        message: error.message,
        position: 'bottom-right',
      });
      return;
    }

    this.loadData();
  }

  private async onEdit(row: EnterLeave) {
    this.isEdit = true;

    let details: EnterLeave;
    try {
      details = await this.$store.dispatch('enterLeave/getEnterLeave', row.id);
    } catch (error) {
      details = JSON.parse(JSON.stringify(row));
    }

    const form: EditInfo = {
      studentList: [{ id: details.studentId, name: details.studentName }],
      enterLeaveState: details.entryAndExit,
      enterLeaveDateTime: details.date,
    };

    let result: EditInfo;
    try {
      result = await (this.$refs.enterLeaveEdit as DialogWrapper).open({...form}) as EditInfo;
    } catch (error) {
      return;
    }

    const enterLeave: EnterLeave = {
      id: row.id,
      studentId: row.studentId,
      studentUserId: row.studentUserId,
      studentName: row.studentName,
      entryAndExit: result.enterLeaveState,
      entryAndExitName: getEntryAndExitTypeName(result.enterLeaveState),
      date: result.enterLeaveDateTime,
    };

    const studentName = row.studentName;
    const enterLeaveState = getEntryAndExitTypeName(result.enterLeaveState);
    const enterLeaveDateTime = (this as any).$moment(result.enterLeaveDateTime).format('YYYY/MM/DD HH:mm');
    const target = `${studentName}<br>${enterLeaveState}　${enterLeaveDateTime}`;
    try {
      await this.$store.dispatch('enterLeave/editEnterLeave', enterLeave);
      this.$notify({
        title: '変更完了',
        message: `<strong>${target}</strong><br>に変更しました。`,
        position: 'bottom-right',
        dangerouslyUseHTMLString: true,
      });
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
        message: error.message,
        position: 'bottom-right',
      });
      return;
    }
  }

  private async onDelete(row: EnterLeave) {
    const studentName = row.studentName;
    const enterLeaveState = row.entryAndExit === EntryAndExitTypes.Exit ? '退室' : '入室';
    const enterLeaveDateTime = (this as any).$moment(row.date).format('YYYY/MM/DD HH:mm');
    const target = `${studentName}<br>${enterLeaveState}　${enterLeaveDateTime}`;
    try {
      await this.$confirm(`<strong>${target}</strong><br>を削除します。よろしいですか？`, '入退室履歴削除', {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning',
        dangerouslyUseHTMLString: true
      });
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('enterLeave/deleteEnterLeave', row.id);
      this.$notify({
        title: '削除完了',
        message: `<strong>${target}</strong><br>を削除しました。`,
        position: 'bottom-right',
        dangerouslyUseHTMLString: true
      });
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
        message: error.message,
        position: 'bottom-right',
      });
    }
  }

  private async onExport() {
    try {
      await this.$store.dispatch('enterLeave/downloadEnterLeaves', this.condition);
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }
}
